import { Pagination } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { IPagination, PaginationPosition } from '../model';
import {
  getDefaultPaginationInfo,
  getDefaultPageSizeOptions,
} from '../libs/pagination';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly onChange?: (page: number, pageSize: number) => void;
  readonly pagination?: IPagination;
  readonly pageSizeOptions?: Array<string> | undefined;
}

export const PaginationComponent = (props: IProps) => {
  const pagination = getDefaultPaginationInfo(props.pagination);
  const pageSizeOptions = props.pageSizeOptions || getDefaultPageSizeOptions();
  const onChange = (page: number, pageSize: number) => {
    if (props.onChange) {
      props.onChange(page, pageSize);
    }
  };

  const renderShowTotal = () => {
    if (props.pagination?.showTotal === null) {
      return null;
    }
    if (props.pagination?.showTotal === true) {
      return getFormatMessage('total_items', {
        params: {
          total: pagination.total,
        },
      });
    }
    if (props.pagination?.showTotal) {
      return props.pagination.showTotal(pagination.total, pagination);
    }
    return getFormatMessage('autoTable_pagination_text', {
      params: {
        pagination: pagination.total,
      },
    });
  };

  const position = props.pagination?.position || PaginationPosition.bottomRight;
  const className = classNames('pagination-box', {
    [`pos-${position}`]: true,
  });

  return (
    <Pagination
      className={className}
      defaultCurrent={pagination.current}
      current={pagination.current}
      defaultPageSize={pagination.pageSize}
      onChange={onChange}
      total={pagination.total}
      hideOnSinglePage={false}
      showTotal={renderShowTotal}
      showSizeChanger={true}
      size="small"
      pageSizeOptions={pageSizeOptions}
    />
  );
};
